var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLaptopAccaBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 38.5H49C49.6446 38.5 50.1667 39.0221 50.1667 39.6667V40.8333C50.1667 43.4087 48.0755 45.5 45.5 45.5H10.5C7.92462 45.5 5.83337 43.4087 5.83337 40.8333V39.6667C5.83337 39.0221 6.35546 38.5 7.00004 38.5Z",
    fill: "#2C6CCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 38.5H32.6667V39.0833C32.6667 40.3725 31.6225 41.4167 30.3334 41.4167H25.6667C24.3775 41.4167 23.3334 40.3725 23.3334 39.0833V38.5Z",
    fill: "#3987F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 10.5H45.5001C46.7892 10.5 47.8334 11.5442 47.8334 12.8333V38.5H8.16675V12.8333C8.16675 11.5442 9.21091 10.5 10.5001 10.5Z",
    fill: "#73A9EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6483 28.1575C26.0775 28.1575 28.0467 26.1883 28.0467 23.7592C28.0467 21.33 26.0775 19.3608 23.6483 19.3608C21.2192 19.3608 19.25 21.33 19.25 23.7592C19.25 26.1883 21.2192 28.1575 23.6483 28.1575Z",
    fill: "#D1E6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9637 24.4534H25.5004C24.8561 24.4534 24.3337 24.9757 24.3337 25.62V32.0834C24.3337 32.7277 24.8561 33.25 25.5004 33.25H31.9637C32.6081 33.25 33.1304 32.7277 33.1304 32.0834V25.62C33.1304 24.9757 32.6081 24.4534 31.9637 24.4534Z",
    fill: "#94C6F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4934 20.2826L29.8988 15.8493C29.5109 15.5897 28.9888 15.8668 28.9888 16.3334V25.2001C28.9888 25.6668 29.5109 25.9439 29.8988 25.6843L36.4934 21.2509C36.8375 21.0205 36.8375 20.513 36.4934 20.2826Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaptopAccaBlue);
export default __webpack_public_path__ + "static/media/icon_laptop_acca_blue.8be9b83d.svg";
export { ForwardRef as ReactComponent };